import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import ChartDirection from './ChartDirection';
import { useMemo } from 'react';
import ChartJsBarChart from '../../../components/charts/ChartJsBarChart';

interface VehiclesDataProps {
  salesPerModelData: any;
}

const VehiclesData = ({ salesPerModelData }: VehiclesDataProps) => {
  const { t, i18n } = useTranslation();

  const chartData = useMemo(() => {
    return salesPerModelData?.data?.data?.map((item: any) => ({
      x: item.model_name?.[i18n.language as 'ar' | 'en'],
      value: item.units_sold
    })) || [];
  }, [salesPerModelData])

  return (
    <div>
      <ListHeader customClass="row">
        <h2>{t('dashboardCharts.vehicles')}</h2>
      </ListHeader>

      <div className="dashboard-data vehicles">
        <div className="charts">
          <ChartDirection>
            <ChartJsBarChart
              data={chartData}
              title={t('dashboardCharts.model_sales')}
              height={400}
              yAxisLabel={t('dashboardCharts.units_sold')}
              tooltipLabel={t('dashboardCharts.units_sold')}
              stroke="#000"
            />
          </ChartDirection>
        </div>

        {/* <div className="top-dashboard-data">
          <TopData data={vehiclesData?.top_brands} header={t('dashboardCharts.top_makes')} />
          <TopData data={vehiclesData?.top_models} header={t('dashboardCharts.top_models')} />
        </div> */}
      </div>
    </div>
  );
};

export default VehiclesData;